import { DateTime } from 'luxon';

export function formatDateTime(dateTimeString: string) {
  if (!dateTimeString) return 'Date not available.';

  const tz = process.env.REACT_APP_LODGING_LOCATION_TIMEZONE;
  const dateTime = DateTime.fromISO(dateTimeString, { zone: tz });
  const formattedDateTime = dateTime.toFormat('LLL dd, yyyy @ hh:mm a');

  return formattedDateTime;
}
